import { render, staticRenderFns } from "./ListagemClientes.vue?vue&type=template&id=09550c44"
import script from "./ListagemClientes.vue?vue&type=script&lang=js"
export * from "./ListagemClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports